import { yupResolver } from '@hookform/resolvers/yup';
import { FC } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useDependenciesValues } from '../../hooks/useDependenciesValues';
import { ReservationListReportFormModel } from '../../models';
import { FilterForm } from './FilterForm';
import { schema } from './schema';

export const FilterFormProvider: FC<{
  defaultValues: ReservationListReportFormModel;
  onSubmit: (data: ReservationListReportFormModel) => void;
}> = ({ defaultValues, onSubmit }) => {
  const form = useForm<ReservationListReportFormModel>({
    defaultValues,
    resolver: yupResolver(schema),
  });

  useDependenciesValues(form);

  return (
    <FormProvider {...form}>
      <FilterForm onSubmit={onSubmit} onReset={() => form.reset(defaultValues)} />
    </FormProvider>
  );
};
